export default __webpack_public_path__ + "static/media/Constructiondick.2c244f6e.PNG";